import React from "react";
import Modal from "react-modal";
import { Button as BtnPrimary } from "@talentbait/shared-components";
import { t } from "i18next";

class Modal__YesNo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.show
    };
  }

  noClicks() {
    this.props.noClick();
  }

  render() {
    var label = this.props.yesLabel || t("Yes");

    if (this.props.isProcessing) {
      label = "...";
    }

    return (
      <div className="draft">
        <Modal
          isOpen={this.props.show}
          style={{
            content: {
              width: "600px",
              top: "10%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              padding: 0,
              marginRight: "-50%",
              transform: "translate(-50%, 0%)"
            }
          }}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          <div className="modal__section">
            <h1 style={{ fontSize: 20, marginBottom: 10 }}>{this.props.headline}</h1>
            <p>{this.props.text}</p>
            <br />
            <div style={{ textAlign: "right" }}>
              <BtnPrimary type="primary" size="medium" mr={10} onClick={this.props.yesClicks}>
                {label}
              </BtnPrimary>
              <BtnPrimary
                type="tertiary"
                size="medium"
                variant="outline"
                onClick={this.noClicks.bind(this)}
              >
                {t("No")}
              </BtnPrimary>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Modal__YesNo;
